import { render, staticRenderFns } from "./RegisterIncidenceModal.vue?vue&type=template&id=ff51ea0a&scoped=true"
import script from "./RegisterIncidenceModal.vue?vue&type=script&lang=js"
export * from "./RegisterIncidenceModal.vue?vue&type=script&lang=js"
import style0 from "./RegisterIncidenceModal.vue?vue&type=style&index=0&id=ff51ea0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff51ea0a",
  null
  
)

export default component.exports